import { useTranslation } from '@/i18n';
import { FormField } from '@/components/Shared/FormField';
import { Checkbox } from '@/components/Shared/Checkbox';
import { Grid, Section } from './SettingsSection';
import type { VehicleSettingsChange, VehicleSettingsForm } from './vehicleSettingsForm';

interface VehicleSettingsSectionProps {
  values: VehicleSettingsForm;
  onChange: VehicleSettingsChange;
}

/**
 * Bereich „Fahrzeuge“ of the tenant settings (FAFD-68), under the time clock. State and saving
 * stay with TenantSettingsPage (one save for the page).
 */
export function VehicleSettingsSection({ values, onChange }: VehicleSettingsSectionProps) {
  const { t } = useTranslation('tenantSettings');
  return (
    <Section title={t('sections.vehicles.title')} description={t('sections.vehicles.description')}>
      <Grid>
        {/* Official logbook: private trips only where the company allows them. */}
        <FormField label={t('fields.allowPrivateTrips')}>
          <Checkbox
            label={t('hints.allowPrivateTrips')}
            hint={t('hints.allowPrivateTripsDetail')}
            checked={values.allowPrivateTrips}
            onChange={(v) => onChange('allowPrivateTrips', v)}
          />
        </FormField>
        {/* Checked when a driver ends a trip; a field that is not required raises no logbook issue. */}
        <FormField label={t('fields.tripRequiredFields')} helperText={t('hints.tripRequiredFields')}>
          <div className="space-y-2">
            <Checkbox
              label={t('hints.tripStartRequired')}
              checked={values.tripStartRequired}
              onChange={(v) => onChange('tripStartRequired', v)}
            />
            <Checkbox
              label={t('hints.tripDestinationRequired')}
              checked={values.tripDestinationRequired}
              onChange={(v) => onChange('tripDestinationRequired', v)}
            />
            <Checkbox
              label={t('hints.tripPurposeRequired')}
              hint={t('hints.tripPurposeRequiredDetail')}
              checked={values.tripPurposeRequired}
              onChange={(v) => onChange('tripPurposeRequired', v)}
            />
          </div>
        </FormField>
        <FormField label={t('fields.flagTripsOutsideWorkingTime')}>
          <Checkbox
            label={t('hints.flagTripsOutsideWorkingTime')}
            hint={t('hints.flagTripsOutsideWorkingTimeDetail')}
            checked={values.flagTripsOutsideWorkingTime}
            onChange={(v) => onChange('flagTripsOutsideWorkingTime', v)}
          />
        </FormField>
      </Grid>
    </Section>
  );
}
